<div class="flex-column f-1-0 gap-2" style="overflow: auto;">

	<trustifi-table-c
		class="trustifi-table" style="flex: 1 0; overflow: auto; z-index: 5;"
		[list]="personalTypes"
		[headers]="[
			{text:'Name', sortKey:'name'},
			{text:'Regex'},
			{text:'Score', sortKey:'sensitivity', width: '100px'},
		]"
		[cellsPrototype]="[
			{textKey:'name', edit: {html: 'nameCellEdit'}},
			{html: 'regexCell', edit: {html: 'regexCellEdit'}},
			{textKey: 'sensitivity', overflowOutside: true, edit: {html: 'scoreCellEdit'}},
		]"
		[cellActions] = "{
			enable: true,
			selectItemActionCb:	selectSensitivityTypeActions,
			initActionsFunction: showSensitivityTypeActions,
			showInRed: {enable: true, terms: ['Delete']}
		}"
		[bulkActions] = "{
			enable: true,
			selectBulkActionCb:	selectMultipleSensitivityTypeAction,
			initBulkActionsFunction: showSensitivityTypeBulkActions,
			showInRed: {enable: true, terms: ['Delete']}
		}"
		(searchFunction)="searchType($event.searchTerm, $event.activeFilters)"
		(confirmEditFunction)="confirmEditType($event.item, $event.isApproved)"
		[options]="{
			defaultSortKey: '-name',
			loadingTableFlag: getSensitivityTypesInProcess,
			itemsNameSingular: 'sensitivity type',
			exportToCsvFunction: exportToCsv,
		}"
	>
		<ng-template #customCells let-item let-cellId="cellId">
			<!--name cells - EDIT-->
			<span class="h-100 flex-column justify-content-center" style="padding-right: 20%;" *ngIf="cellId === 'nameCellEdit'">
				<input *ngIf="item.isNew"
					   id="personalTypeNameEditInput" type="text"
					   class="h-100" placeholder="Name"
					   [(ngModel)]="item.edit.name">
				<span *ngIf="!item.isNew">{{item.name}}</span>
			</span>
			<!--regex cells-->
			<span *ngIf="cellId === 'regexCell'">
				<span class="text-muted">/</span>{{item.regex || ''}}<span class="text-muted">/</span>{{item.regex_flags || ''}}
			</span>
			<!--regex cells - EDIT-->
			<span *ngIf="cellId === 'regexCellEdit'">
				<div class="flex-row gap-2 align-items-center h-100" style="padding-right: 20%;">
					<span class="text-muted" style="font-size: 1.6em;">/</span>
					<input type="text" id="personalTypeRegexEditInput"
						   class="h-100 f-1-0" placeholder="Regex (JavaScript)"
						   [(ngModel)]="item.edit.regex">
					<span class="text-muted" style="font-size: 1.6em;">/</span>
					<input type="text" id="personalTypeRegexEditInput"
						   class="h-100 f-1-0" style="max-width: 60px;"
						   placeholder="Flags"
						   [(ngModel)]="item.edit.regex_flags">
				</div>
			</span>
			<!--score cells - EDIT-->
			<span *ngIf="cellId === 'scoreCellEdit'">
				<app-dropdown-c style="width: 50px; height: 100%;" text="{{item.edit.sensitivity}}">
					<li *ngFor="let sen of [1,2,3,4,5]"
						(click)="item.edit.sensitivity = sen">
						{{sen}}
					</li>
				</app-dropdown-c>
			</span>
		</ng-template>

		<div tableButtons>
			<!--Add Type button-->
			<div class="w100">
				<btn-c endIcon="far fa-plus"
					   [isDisabled]="addTypeInProcess"
					   (action)="startAddType();">
					Add Sensitivity Type
				</btn-c>
			</div>
		</div>
	</trustifi-table-c>
</div>

